/*
 * Simple Image
 *
 * Supports:
 * - Retina
 * - Lazy loading of full resolution src
 * - Webp src for suitable browsers
 */

import React, { useRef } from 'react';

import { useLazyImage } from '$hooks/images';

const emptySrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').SimpleImage}
 */
export const SimpleImage = ({
    alt,
    className,
    psrc,
    px2,
    role,
    src,
    style,
    x2
}) => {
    const imageRef = useRef(null);

    const {
        imageSrc,
        imageX2,
        loaded
    } = useLazyImage({
        imageRef,
        src,
        psrc,
        x2,
        px2
    });

    return (
        <img
            alt={alt}
            className={className}
            ref={imageRef}
            role={role}
            src={imageSrc || emptySrc}
            srcSet={imageX2 ? `${imageX2} 2x` : undefined}
            style={{
                opacity: loaded ? 1 : 0,
                transition: 'opacity .3s',
                ...style
            }} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default SimpleImage;
